import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createProcedureSchemas } from 'shared/db/validation/schemas/procedure';
import { Validator } from 'shared/db/validation/validator';
import { ProcedureRawRecord } from 'shared/types/Procedures';
import { DeleteRawRecord, UpdateRawRecord } from 'shared/types/rawRecordFields';
import { ProcedureEntityDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createProcedureSchemas();

const addValidator = createDBEntityValidator<ProcedureRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<
    UpdateRawRecord<ProcedureRawRecord>
>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-procedures'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createProceduresInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const proceduresInputValidation: ProcedureEntityDBValidation = {
    add: createProceduresInputValidation(addValidator, validationStrategy),
    update: createProceduresInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createProceduresInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
